import { combineReducers, createStore, applyMiddleware } from "redux";
import thunk from "redux-thunk";

import { reducer as notifications } from "react-notification-system-redux";

import {
  loginReducer,
  signupReducer,
  forgotPasswordReducer,
  mailConfirmationReducer,
  invateReducer,
  resetPasswordReducer,
  queryPageRequest,
  queryPageProgramRequest,
  queryPageByIdRequest,
  getRequest,
  getByIdRequest,
  postRequest,
  postByIdRequest,
  postSetRequest,
  putRequest,
  putByIdRequest,
  deleteRequest,
  setRequest,
  downloadRequest,
  programSave,
  reportActivityList,
  reportActivityProfileImage,
  newCount,
  listType,
} from "./redux/reducers/index";


const reducer = combineReducers({

  // Notification
  notifications: notifications,

  // Auth
  login: loginReducer,
  signup: signupReducer,
  forgetPass: forgotPasswordReducer,
  mailConfirmation: mailConfirmationReducer,
  resetPassword: resetPasswordReducer,
  invateUser: invateReducer,
  //master
  interestList: getRequest('interest/list'),
  countryList: getRequest('country/list'),
  languageList: getRequest('language/list'),
  workingAreaList: getRequest('working/area/list'),
  organizationList: getRequest('organization/list'),
  
  // Leaderboard
  leaderboardQueryPage: queryPageRequest('researcher/leaderboard'),
  // leaderboardLastWeekList: getRequest('leaderboard/lastweek/list'),
  // leaderboardLastMonthList: getRequest('leaderboard/lastmonth/list'),
  
  // Program
  programListType: listType('program'),
  programAllList: getRequest('program/all/list'),
  programAllQueryPage: queryPageProgramRequest('program/all'),
  programStat: getByIdRequest('program/stat'),
  programReportStat: getByIdRequest('program/report/stat'),
  programId: getByIdRequest('program/id'),
  programScope: getByIdRequest('program/scope/byprogram'),
  programReward: getByIdRequest('program/reward/byprogram'),
  programInfoGetInfo: getRequest('program/info/get/info'), 
  programSave: programSave(),
  programRewardSave: postByIdRequest('program/reward/save'),
  programScopeSave: postByIdRequest('program/scope/save'),
  programSubmit: programSave(),
  programClose: putByIdRequest('program/close'),
  programPaymentTransactionList: getByIdRequest('program/payment/transaction/list'),
  programPaymentFile: getByIdRequest('program/download/program/payment/file'),
  programAttachPayment: postByIdRequest('program/attach/payment'),
  programUpdatesQueryPage: queryPageByIdRequest('program/update'),
  programResearcherJoinByProgramQueryPage: queryPageByIdRequest('researcher/program/join/byprogram'),
  programReportByProgramQueryPage: queryPageByIdRequest('program/report/byprogram'),
  programUpdateName: postByIdRequest('program/update/name'),
  programUpdateDescription: postByIdRequest('program/update/description'),
  programUpdateFocusarea: postByIdRequest('program/update/focusarea'),
  programUpdateRules: postByIdRequest('program/update/rules'),
  programUpdateDisclosure: postByIdRequest('program/update/disclosure'),
  programUpdateEligibility: postByIdRequest('program/update/eligibility'),
  programUpdateDates: postByIdRequest('program/update/date'),
  programUpdateId: getByIdRequest('program/update/id'),
  programScopeBeforeUpdateByprogram: getByIdRequest('program/scope/before/update/byprogram'),
  programScopeUpdateByprogram: getByIdRequest('program/scope/update/byprogram'),

  programUpdateRevoke: putByIdRequest('program/update/revoke'),
  researcherProgramJoinRecentlyListByprogram: getByIdRequest('researcher/program/join/recently/list/byprogram'),

  // Report
  programReportQueryPage: queryPageRequest('program/report/organization/all'),
  programReportId: getByIdRequest('program/report/id'),
  programReportAttachmentFileList: getByIdRequest('program/report/attachment/file/list'),
  programReportAttachmentFileDownload: downloadRequest('program/report/attachment/file/download'),

  programReportActivityByReport: reportActivityList(),
  reportActivityProfileImage: reportActivityProfileImage(),
  programReportActivityCommentCreate: postByIdRequest('program/report/activity/comment/create'),
  programReportObjectionCreate: postByIdRequest('program/report/activity/objection/create'),
  programReportTagAs: postSetRequest('program/report/activity/tag/report'),
  programReportChangeStatus: postSetRequest('program/report/change/status'),
  programReportAssignPersonnel: setRequest('program/report/assign/personnel'),
  programReportSetReward: postByIdRequest('program/report/activity/set/reward'),
  programReportRequestRetest: postByIdRequest('program/report/activity/request/retest'),
  programReportActivitySetDisclosure: setRequest('program/report/activity/set/disclosure'),
  programReportActivityRequestDisclosureDisable: postByIdRequest('program/report/activity/request/disclosure/disable'),
  programReportActivityAttachmentFileDownload: downloadRequest('program/report/activity/attachment/file/download'),

  // Team
  organizationTeamMemberQueryPage: queryPageRequest('organization/team/member'),
  organizationTeamMembeSave: postRequest('organization/team/member/save'),
  organizationTeamMemberSetArchive: putByIdRequest('organization/team/member/set/archive'),
  organizationTeamMemberResendValidation: putByIdRequest('organization/team/member/resend'),
  organizationTeamMemberId: getByIdRequest('organization/team/member/id'),
  organizationTeamMemberProgramAccessSave: postByIdRequest('organization/team/member/program/access/save'),
  organizationTeamMemberProgramAccessBymember: getByIdRequest('organization/team/member/program/auth/bymember'),

  // Activities
  organizationPaymentDepositTransactionQueryPage: queryPageRequest('organization/payment/deposit/transaction'),
  organizationPaymentDepositReview: getRequest('organization/payment/deposit/review'),
  organizaitonPaymentProgramBalanceQueryPage: queryPageRequest('organizaiton/payment/program/balance'),

  paymentTransactionOrganizationDepositReview: getRequest('payment/transaction/organization/deposit/review'),
  paymentTransactionOrganization: queryPageRequest('payment/transaction/organization'),
  paymentTransactionOrganizationProgramBalanceActivityReview: getRequest('payment/transaction/organization/program/balance/activity/review'),

  //Profile
  companyProfileBase: getRequest('organization/profile/base'),
  organizationPaymentMethod: getRequest('organization/payment/method/byorganization'),
  organizationUserProfileInformation: getRequest('team/member/profile/base'),
  organizationUserProfileSub: getRequest('team/member/profile/sub'),
  organizationUserProfileBaseInformation: getRequest('organization/team/member/profile/base'),
  profileSecurityInformation: queryPageRequest('logging/login'),
  ImageSave: postRequest('user/save/profile/image'),

  organizationBusinessProfileBase: getRequest('organization/profile/base'),
  organizationBusinessProfileSub: getRequest('organization/profile/sub'),
  organizationUserProfileSubEdit: postRequest('team/member/profile/personel/details/update'),
  organizationProfileDetailEdit: postRequest('organization/profile/details/update'),
  organizationProfileSocialEdit: postRequest('organization/profile/socialmedia/update'),
  organizationBusinessProfileSubEdit: postRequest('organization/profile/sub/update'),
  organizationBusinessProfileAboutus: postRequest('organization/profile/about/update'),
  organizationPaymentMethodSave: postRequest('organization/payment/method/save'),
  changePass: postRequest('user/change/password'),

  organizationStatTotalReward: getRequest('organization/stat/total/reward'),
  organizationStatProgram: getRequest('organization/stat/program'),
  organizationStatReport: getRequest('organization/stat/program/report'),


  //Researcher Profile
  researcherByIdProfileSub: getByIdRequest('researcher/profile/general/sub'),
  researcherByIdProfileInformation: getByIdRequest('researcher/profile/general/base'),
  researcherByIdProfileSkill: getByIdRequest('researcher/skill/general/byresearcher'),
  researcherByIdProfileInterest: getByIdRequest('researcher/interest/general/byresearcher'),
  researcherByIdProfilePerformance: getByIdRequest('researcher/profile/general/performance'),
  researcherByIdProfilePerformanceBadges: getByIdRequest('researcher/profile/general/badges'),
  researcherProfileGeneralProgramShow: getByIdRequest('researcher/profile/general/program/show'),
  researcherProgramRecentlyJoinedList: getByIdRequest('researcher/program/recently/joined/list'),
  researcherProgramRecentlyFollowingList: getByIdRequest('researcher/program/recently/following/list'),
  
  // Team Member Profile
  teamMemberByIdProfileSub: getByIdRequest('team/member/profile/organization/sub'),
  teamMemberByIdProfileInformation: getByIdRequest('team/member/profile/organization/base'),

  //Topbar Right Announcement
  notificationTaskNewCount: newCount('notification/task/newcount'),
  notificationActivityNewCount: newCount('notification/activity/newcount'),

  //Notification
  notificationTaskShort: queryPageRequest('notification/task/short'),
  notificationTask: queryPageRequest('notification/task'),
  notificationActivityShort: queryPageRequest('notification/activity/short'),
  notificationActivity: queryPageRequest('notification/activity'),
  notificationAnnouncementShort: queryPageRequest('notification/announcement/short'),
  notificationAnnouncement: queryPageRequest('notification/announcement'),
  notificationBaseNewCount: newCount('notification/base/newcount'),

  // Announcement
  announcementQueryPage: queryPageRequest('organization/announcement'),
  announcementSave: postRequest('organization/announcement/save'),

  //Hacktions
  programHacktionQueryPage: queryPageRequest('program/report/hacktion'),
  
  programReportSummaryId: getByIdRequest('program/report/summary/id'),
  programReportAttachmentFileHacktivityList: getByIdRequest('program/report/attachment/file/hactivity/list'),
  programReportAttachmentFileHacktivityDownload: downloadRequest('program/report/attachment/file/hactivity/download'),

  programReportHacktionActivityByReport: getByIdRequest('program/report/activity/byreport'),
  programReportActivityAttachmentFileHacktivityDownload: downloadRequest('program/report/activity/attachment/file/hactivity/download'),


  
});

const store = createStore(reducer, applyMiddleware(thunk));

export default store;
